import React, { useEffect, useState, useCallback } from 'react';
import { Upload, Download, FileText, RefreshCw } from 'lucide-react';
import { documentsApi, documentDownloadUrl } from '../../Api/BaseApi';
import { useTheme } from '../../Context/ThemeContext';
import './index.css';

const fmtBytes = (b) => {
  if (!b) return '—';
  const u = ['B', 'KB', 'MB', 'GB'];
  let i = 0, n = b;
  while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${u[i]}`;
};
const fmtDate = (s) => (s ? new Date(s).toLocaleString() : '');

const Folder = ({ title, icon, docs, emptyText }) => (
  <section className="doc-folder">
    <h2 className="doc-folder-title">{icon}{title}<span className="doc-count">{docs.length}</span></h2>
    {docs.length === 0 ? (
      <p className="doc-empty">{emptyText}</p>
    ) : (
      <table className="doc-table">
        <thead>
          <tr><th>Name</th><th>Type</th><th>Size</th><th>Date</th><th></th></tr>
        </thead>
        <tbody>
          {docs.map((d) => (
            <tr key={d.id}>
              <td className="doc-name"><FileText size={15} /> {d.name}</td>
              <td>{d.description || d.content_type}</td>
              <td>{fmtBytes(d.size_bytes)}</td>
              <td>{fmtDate(d.created_at)}</td>
              <td>
                <a className="doc-download" href={documentDownloadUrl(d.id)} target="_blank" rel="noreferrer">
                  Download
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
);

const Documents = () => {
  const { isDarkMode } = useTheme();
  const [uploads, setUploads] = useState([]);
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([documentsApi('upload'), documentsApi('download')])
      .then(([u, d]) => { setUploads(u); setDownloads(d); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className={`documents-page ${isDarkMode ? 'dark-mode' : ''}`}>
      <header className="documents-header">
        <div>
          <h1>Documents</h1>
          <p className="documents-sub">All files uploaded to and generated by Pinaka.</p>
        </div>
        <button className="doc-refresh" onClick={load}><RefreshCw size={15} /> Refresh</button>
      </header>
      {loading && <p className="doc-empty">Loading…</p>}
      <Folder title="Uploads" icon={<Upload size={17} />} docs={uploads}
              emptyText="No uploaded files yet. Attach a portfolio in the chat to see it here." />
      <Folder title="Downloads" icon={<Download size={17} />} docs={downloads}
              emptyText="No generated outputs yet. Charts and end-of-day summaries appear here." />
    </div>
  );
};

export default Documents;
